import JoditEditor, { IJoditEditorProps } from "jodit-react";
import { useRef, useEffect, useState, useMemo } from "react";
import { debounce } from "lodash";

interface HtmlCodeProps {
  content: string;
  setContent: (content: string) => void;
  label?: string;
  versionedValue?: string;
  isVersioned?: boolean;
  placeholder?: string;
}

const HtmlCode: React.FC<HtmlCodeProps> = ({
  content,
  setContent,
  label,
  versionedValue,
  isVersioned,
  placeholder = "start tyiping text",
}) => {
  const editor = useRef(null);
  // const handleBlur = debounce((newContent) => {
  //   console.log("Editor lost focus. Content:", newContent);

  //   setContent(newContent);
  // }, 2000);
  const handleBlur = (newContent: string) => {
    //console.log("Editor lost focus. Content:", newContent);

    setContent(newContent);
  };
  // console.log(content);

  const handlePaste = (e: ClipboardEvent) => {
    let pastedContent =
      e.clipboardData?.getData("text/html") ||
      e.clipboardData?.getData("text/plain") ||
      "";

    pastedContent = pastedContent.replace(
      /<script[\s\S]*?>[\s\S]*?<\/script>/gi,
      ""
    );

    if (editor.current && editor.current.editor) {
      const editorInstance = editor.current.editor;
      editorInstance.selection.insertHTML(pastedContent);
      console.log(editor.current.editor);
    }

    e.preventDefault();
  };

  const handleChange = debounce((newContent: string) => {
    setContent(newContent);
  }, 700);
  const configed = {
    readonly: true, // Make the editor read-only
    height: "50%",
    uploader: {
      insertImageAsBase64URI: true,
    },
    placeholder: "Start typing here...",
    toolbar: false, // Optional: Hide toolbar for a cleaner, readonly view
  };
  const config = useMemo(
    () => ({
      readonly: false,
      height: "300px",
      // Ensures the editor is editable

      uploader: {
        insertImageAsBase64URI: true,
      },
      placeholder: placeholder || "Start typing here...",
      // events: {
      //   paste: handlePaste,
      // },
      // buttons: [
      //   "bold",
      //   "italic",
      //   "underline",
      //   "|",
      //   "ul",
      //   "ol",
      //   "|",
      //   "outdent",
      //   "indent",
      //   "|",
      //   "image",
      //   "|",
      //   "align",
      //   "undo",
      //   "redo",
      //   "|",
      //   "hr",
      //   "eraser",
      //   "fullsize",
      // ],
    }),
    [placeholder]
  );

  // Ensure content and versionedValue are always strings and handle null/undefined cases
  const safeContent = useMemo(() => {
    if (content === null || content === undefined) return "";
    return String(content);
  }, [content]);

  const safeVersionedValue = useMemo(() => {
    if (versionedValue === null || versionedValue === undefined) return "";
    return String(versionedValue);
  }, [versionedValue]);

  return (
    <>
      {isVersioned ? (
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          <p className="inline-block text-base font-medium">Old Text</p>
          <div className="xl:col-span-12">
            <label
              htmlFor="phoneNumberIn"
              className="inline-block mb-2 text-base font-medium"
            >
              {label}
            </label>
            <JoditEditor
              ref={editor}
              value={safeVersionedValue}
              config={configed}
              onBlur={handleBlur}
              // onChange={handleChange}
            />
          </div>
        </div>
      ) : null}
      <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
        <p className="inline-block mt-4 text-base font-medium">New Text</p>
        <div className="xl:col-span-12">
          <label
            htmlFor="phoneNumberIn"
            className="inline-block mb-2 text-base font-medium"
          >
            {label}
          </label>
          <JoditEditor
            ref={editor}
            value={safeContent}
            config={config}
            onBlur={handleBlur}
            // onChange={handleChange}
          />
        </div>
      </div>
    </>
  );
};

export default HtmlCode;
